import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default () => {
  const { commit, state } = useStore()
  const route = useRoute()

  const tasks = computed(() => state.task.tasks)
  const events = computed(() => state.planner.events)
  const user = computed(() => state.profile.user)
  const depthPageMessages = computed(() => state.chat.depthPageMessages)
  const messages = computed(() => state.chat.messages)

  const isTaskBoard = computed(() => route.name === 'TaskBoard' || route.name === 'TaskBoardTeam')
  const isWeekPlanner = computed(() => route.name === 'WeekPlanner' || route.name === 'WeekPlannerTeam')

  function addMessage (parsedData) {
    const message = parsedData.payload.message

    if (isTaskBoard.value) {
      const task = tasks.value.find(t => t.chat?.id === message.chatId)

      if (task) {
        let messages = task.chat.messages || []

        if (messages.some(m => m.id === message.id)) {
          messages = messages.map(item => {
            if (item.id === message.id) return message
            return item
          })
        } else {
          messages.push(message)
        }

        commit('updateTask', {
          id: task.id,
          chat: {
            ...task.chat,
            messages: messages
          }
        })
      }
    }

    if (isWeekPlanner.value) {
      const event = events.value.find(e => e.event?.chat?.id === message.chatId)

      if (event) {
        let messages = event.event.chat.messages || []

        if (messages.some(item => item.id === message.id)) {
          messages = messages.map(item => {
            if (item.id === message.id) return message
            return item
          })
        } else {
          messages.push(message)
        }

        commit('updateEvent', {
          id: event.id,
          event: {
            ...event.event,
            chat: {
              ...event.event.chat,
              messages: messages
            }
          }
        })
      }
    }

    if (depthPageMessages.value.some(i => i.chatId === message.chatId) && message.user.id !== user.value.id) {
      commit('addDepthPageMessage', message)
    }

    if (messages.value.some(i => i.chatId === message.chatId) && message.user.id !== user.value.id) {
      commit('setMessage', message)
    }
  }

  function deleteMessage (parsedData) {
    commit('deleteMessage', parsedData.payload.value.id)

    if (isTaskBoard.value) {
      const task = tasks.value.find(t => t.chat?.id === parsedData.payload.value.chatId)

      if (task) {
        commit('updateTask', {
          id: task.id,
          chat: {
            ...task.chat,
            messages: task.chat.messages?.filter(item => item.id !== parsedData.payload.value.id)
          }
        })
      }
    }

    if (isWeekPlanner.value) {
      const event = events.value.find(e => e.event?.chat?.id === parsedData.payload.value.chatId)

      if (event) {
        commit('updateEvent', {
          id: event.id,
          event: {
            ...event.event,
            chat: {
              ...event.event.chat,
              messages: event.event.chat.messages?.filter(item => item.id !== parsedData.payload.value.id) || []
            }
          }
        })
      }
    }
  }

  function updateMessage (parsedData) {
    commit('updateMessage', parsedData.payload.value)
  }

  function initChat (parsedData) {
    if (parsedData.payload.type === 'addMessage') {
      addMessage(parsedData)
    } else if (parsedData.payload.type === 'deleteMessage') {
      deleteMessage(parsedData)
    } else if (parsedData.payload.type === 'updateMessage') {
      updateMessage(parsedData)
    }
  }
  return {
    initChat
  }
}
